<template>
  <v-row v-if="user" justify="center" align="center" no-gutters>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="50"
      :open-on-hover="hover"
      offset-overflow
      offset-y
      top
    >
      <template v-slot:activator="{ on }">
        <v-row
          :class="horizontal ? 'text-center' : ''"
          align="center"
          no-gutters
        >
          <v-badge right bottom overlap small color="transparant" class="mr-3">
            <v-icon
              v-if="user.is_online || blockedUser"
              slot="badge"
              :color="blockedUser ? 'red' : 'green'"
              size="12"
              v-text="$getIcon('mdiEye')"
            >
            </v-icon>
            <v-avatar :size="size" v-on="on">
              <v-img :src="user.picture"></v-img>
            </v-avatar>
          </v-badge>
          <v-col class="text-left">
            <a @click="viewProfileDetail(user.id)">
              {{ user.full_name ? user.full_name : "" }}
            </a>
            <div class="caption grey--text">
              {{ user.job_title ? user.job_title : "" }}
            </div>
          </v-col>
        </v-row>
      </template>
      <v-card>
        <v-img
          :src="user.cover_picture_thumb || user.cover_picture"
          aspect-ratio="4"
        ></v-img>
        <v-row
          :class="horizontal ? 'text-center' : ''"
          align="center"
          justify="start"
          class="mx-0 pa-3"
          no-gutters
        >
          <v-badge right bottom overlap small color="transparant" class="mr-3">
            <v-icon
              v-if="user.is_online || blockedUser"
              slot="badge"
              :color="blockedUser ? 'red' : 'green'"
              size="12"
              v-text="$getIcon('mdiEye')"
            >
            </v-icon>
            <v-avatar :size="size">
              <v-img :src="user.picture"></v-img>
            </v-avatar>
          </v-badge>
          <v-col>
            <a @click="viewProfileDetail(user.id)">
              {{ user.full_name ? user.full_name : "" }}
            </a>
            <div class="caption grey--text">
              {{ user.job_title ? user.job_title : "" }}
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-menu>
  </v-row>
  <span v-else class="my-3" v-text="'N/A'"></span>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    user: {
      type: Object,
      default: undefined
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    size: {
      type: [Number, String],
      default: 35
    },
    blockedUser: {
      type: Boolean,
      default: false
    },
    justifyCenter: {
      type: Boolean,
      default: false
    },
    hover: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    ...mapState({
      appView: "appView"
    })
  },
  methods: {
    viewProfileDetail(userIdentifier) {
      if (this.appView === "userView") {
        this.$router.push({
          path: {
            name: "user-employee-directory-id-profile-detail",
            params: { id: userIdentifier }
          }
        });
      } else {
        this.$router.push({
          name: "admin-slug-hris-users-id",
          params: { id: userIdentifier, slug: this.$route.params.slug }
        });
      }
    }
  }
};
</script>
<style scoped>
.align {
  position: relative;
  top: -5px;
}
</style>
